import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { emailConfirmDOI } from '../../helpers/ergo';

function EmailConfirm(props) {
  const { id, status, lastpage, hash } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    try {
      const response = emailConfirmDOI(id, lastpage, status, hash);
      response.then((res) => {
        if (res.data.success) {
          // TODO get actual dankeseite for user, AKA only one
          // Danke mit Gewinnspiel: user.status = "check"
          // Danke mit Email Termin: user.status = "appointment"
          console.log(res.data, lastpage);
          // console.log(res.data.status);
          // console.log()
          switch (res.data.status) {
            case 'check':
              navigate('/' + id + '/confirmed-thank-you-no-appointment');
              break;
            case 'appointment':
              if (lastpage === 'lp') {
                navigate('/' + id + '/');
              } else {
                navigate('/' + id + '/' + lastpage);
              }
              break;
            default:
              console.log('It was :', status);
              navigate('/' + id + '/confirmed-thank-you');
          }
        }
      });
    } catch (e) {
      console.error('email confirm error: ', e);
      navigate('/' + id);
    }
  }, []);

  return <div>Please wait</div>;
}

export default EmailConfirm;
